import { imageCoverContainer } from '@helpers/aspectRatio';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { baseGrid, siteWide } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { h1 } from '@helpers/typography';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled(m.article) `
  display: grid;
  grid-row: 1 / span 2;
  grid-column: 1;
  height: 100%;
  grid-template-rows: 1fr 2fr;

  @media ${from(Device.MobileLarge)} {
    grid-row: 1 / span 3;
  }
`;
const MediaWrapper = styled(m.div) `
  position: relative;
  display: block;
  grid-row: 1 / span 2;
  grid-column: 1;
  overflow: hidden;
  overflow: clip;
  padding-top: var(--headerHeight);
  user-select: none;
  z-index: 1;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background: rgba(0, 0, 0, var(--tintAmount));
    width: 100%;
  }

  @media ${from(Device.MobileLarge)} {
    grid-row: 1 / span 3;
  }
`;
const Image = styled(m.img) `
  ${imageCoverContainer()}

  &[data-mobile-only=true] {
    @media ${from(Device.MobileLarge)} {
      display: none;
    }
  }
`;
const Video = styled.video `
  ${imageCoverContainer()}

  &[data-hide-mobile=true] {
    @media ${until(Device.Tablet)} {
      display: none;
    }
  }
`;
const Inner = styled.div `
  ${siteWide};
  ${baseGrid};

  position: relative;
  z-index: 2;
  grid-row: 2 / span 1;
  grid-column: 1;

  @media ${from(Device.MobileLarge)} {
    grid-row: 2 / span 2;
    transform: translateY(-1ch);
  }
`;
const ContentWrapper = styled(m.div) `
  grid-column: 1 / span 6;

  @media ${from(Device.MobileLarge)} {
    grid-column: 2 / span 5;
  }
`;
const Title = styled(m.h2) `
  ${h1};

  margin-bottom: ${fluid(12, 26)};

  > span {
    display: inline;
  }

  [data-site='mep'] & {
    ${fonts.museoSlab.medium};

    > span {
      ${fonts.daxWide.bold};
    }
  }
`;
const Content = styled(m.p) `
  ${fonts.daxWide.medium};

  font-size: ${fluid(16, 20)};
  line-height: ${fluid(26, 30)};
  margin-bottom: 0;
`;
const CtaWrapper = styled(m.div) `
  display: block;
  margin-top: ${fluid(24, 40)};
`;
const BannerItemStyles = {
    Container,
    Content,
    ContentWrapper,
    CtaWrapper,
    Image,
    MediaWrapper,
    Inner,
    Title,
    Video,
};
export default BannerItemStyles;
